import { render, staticRenderFns } from "./ChatListDisplay.vue?vue&type=template&id=49dfc508&"
import script from "./ChatListDisplay.vue?vue&type=script&lang=ts&"
export * from "./ChatListDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports